<template>
  <div class="feedBack">
      <div class="flexR" @click='gotoAsk'>在线客服</div>
      <van-field type='textarea' row='4' placeholder='请输入问题描述，点击下方+提交截图，帮助我们更快定位问题' v-model='option' maxlength='1000'></van-field> 
      <div class='imgs'>
          <upload-img uplogType='1' ref='uploadImg'></upload-img>
      </div>

      <div class="btnFixed"> 
          <div class="btn-primary" @click='save'>确定</div>
      </div> 
  </div>
</template>
<script>
  import {feedbackAdd} from '@/api/api.mine.js';
  import uploadImg from '@/components/uploadImg.vue';
  export default {
    data() {
      return {
        userType:this.$store.state.loginUser.currentUserType,//3老师，5家长
        option:'',
        urlList:[]
      }
    },
    components:{uploadImg},
    created(){ 
     
      
    },  
    methods: {
      gotoAsk(){
        window.location.href='https://work.weixin.qq.com/kfid/kfced966109a2c79f49'
      },
      save(){
        if(this.option==''){
          this.$toast('内容不能为空');
          return false;
        }
        if(this.userType==3){//老师
          this.identityId=this.$store.state.users.teacher.teacherId
        }else if(this.userType==5){//家长
          this.identityId=this.$store.state.users.parent.parentId
        }
         let urlList=this.$refs.uploadImg.imgData;
         if(urlList.length>0){
            urlList=urlList.map(item=>item.accessUrl)
         }
          let params={
                schoolId:this.loginUser.schoolId,
                userType:this.userType,
                identityId:this.identityId,
                opinion:this.option,
                accessoryList:urlList
          }
          feedbackAdd(params).then(res=>{
            if(res.code=='00000'){
              this.$toast('提交成功');
              this.option='';
              this.$refs.uploadImg.fileList=[];
               this.$router.go(-1);
            }
          })
       }
    },
    destroyed(){
      clearInterval(this.times)
    }
  }
</script>
<style lang="scss" >
.feedBack{
  padding:.12rem;
  .flexR{
    position: fixed;
    right: .12rem;
    top:.13rem;
    z-index:4;
    color:#0A59F7;
  }
  textarea{
     height:1.5rem;
     font-size: .14rem;
  }
  .van-cell::after{
    border:none;
  }
  .imgs{
    margin-top: .12rem;
    .van-uploader__upload{
      border: 1px solid #e3e3e3;
    }
    i{
      color:#bfc1c2;
    }
  }
}

</style>